import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../home/siteContent';
import { SmartLink } from '../home/ui';
import '../home/home.css';

/*
 * Figma "Footer" (node 33779:43): #243644, 502px tall at 1800.
 * Four 400px columns split by 10%-white dividers, copyright under a 20%-white rule.
 */
const COLUMN_PAD = [
  'lg:pl-[clamp(20px,2.5556vw,46px)]',
  'lg:pl-[clamp(20px,4.1111vw,74px)]',
  'lg:pl-[clamp(20px,4.1667vw,75px)]',
];

const SiteFooter = () => {
  const { content } = useSiteContent();
  const { footer } = content;
  const copyright = String(footer.copyright || '').replace('{year}', new Date().getFullYear());

  return (
    <footer id="footer" className="hp bg-brand-night text-white" data-testid="site-footer">
      <div className="hp-container">
        <div className="grid grid-cols-1 gap-10 pt-12 min-[480px]:grid-cols-3 lg:grid-cols-4 lg:gap-0 lg:pt-[clamp(40px,4.2778vw,77px)] lg:min-h-[min(434px,24.1111vw)]">
          <div className="min-[480px]:col-span-3 lg:col-span-1 lg:pr-6">
            <Link to="/" className="inline-block lg:-mt-[clamp(0px,0.8333vw,15px)]" data-testid="footer-logo-link">
              <img
                src="/brand/logo-white.png"
                alt="WowProfit.io"
                className="h-[clamp(64px,6.2778vw,113px)] w-auto"
              />
            </Link>
            <div className="mt-[clamp(12px,0.8889vw,16px)] max-w-[520px] text-[clamp(15px,1vw,18px)] lg:max-w-[371px] leading-[1.6667]">
              <p>{footer.description}</p>
              <p>{footer.location}</p>
            </div>
          </div>

          {footer.columns.map((col, i) => (
            <div
              key={i}
              className={`lg:border-l lg:border-white/10 lg:pt-[clamp(80px,6.3333vw,114px)] ${COLUMN_PAD[i] || COLUMN_PAD[2]}`}
            >
              <h2 className="text-[clamp(17px,1.1111vw,20px)] font-semibold leading-5">{col.title}</h2>
              <ul className="mt-[clamp(8px,0.6111vw,11px)] break-words text-[clamp(15px,1vw,18px)] leading-[35px]">
                {col.links.map((link) => (
                  <li key={link.label + link.to}>
                    <SmartLink to={link.to} className="transition-colors hover:text-brand">
                      {'>\u00a0'}
                      {link.label}
                    </SmartLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-10 border-t border-white/20 lg:mt-0">
        <p className="hp-container pb-[23px] pt-[15px] font-['Manrope',sans-serif] text-[16px] font-semibold leading-[29px]">
          {copyright}
        </p>
      </div>
    </footer>
  );
};

export default SiteFooter;
